import {
  CanvasDrawingSettings,
  CanvasElementType,
  CanvasObjectPosition,
  CanvasObjectSize,
  CanvasObjectStyles,
} from '@y42/json-schema';
import { Point } from '../types/point';
import type { VisualizationCanvasElementStoreModel } from '../visualization-canvas-element.model';
import { defaultCanvasGenericStyles, defaultCanvasObjectProperties } from './default-canvas-model-properties';

const canvasDrawingDefaultConstant: CanvasObjectStyles = {
  ...defaultCanvasGenericStyles,
  'background-color': 'black',
  'border-color': '#5a9deb',
};

const canvasDrawingDefaultSettings: CanvasDrawingSettings = {
  strokeWidth: 5,
  path: '',
};

const canvasDrawingDefaultSize: CanvasObjectSize = {
  width: 100,
  height: 100,
};

export interface CanvasDrawing {
  path: Point[];
  strokeWidth: number;
  x: number;
  y: number;
  width: number;
  height: number;
}

export function getCanvasDrawingModel(data: {
  position: CanvasObjectPosition;
  strokeWidth: number;
  width: number;
  height: number;
  path: string;
}) {
  return {
    type: CanvasElementType.Drawing,
    position: data.position,
    size: {
      ...canvasDrawingDefaultSize,
      width: data.width,
      height: data.height,
    },
    styles: {
      ...canvasDrawingDefaultConstant,
      'border-width': `${data.strokeWidth}`,
    },
    objectProperties: {
      ...defaultCanvasObjectProperties,
      resizable: true,
    },
    typeSettings: {
      ...canvasDrawingDefaultSettings,
      strokeWidth: data.strokeWidth,
      path: data.path,
    },
  };
}

export type CanvasDrawingModel = VisualizationCanvasElementStoreModel<CanvasElementType.Drawing>;
